export default __webpack_public_path__ + "static/pic03-2308f10e9c575cb9353032164be50d83.jpeg";